export const comments_3389026 = {"data":{"data":[],"links":{}}}